import { FC } from 'react'
import * as styles from 'components/features/pfm/BarChart/BarChart.styl'
import { getBarLength } from 'helpers/categoriesHelpers'

type BarChartProps = {
  memberValue: number
  peerValue: number
  otherValue: number
  max: number
}

export const BarChart: FC<BarChartProps> = (props) => {
  const { memberValue, peerValue, otherValue, max } = props

  return (
    <div className={ styles.barChart }>
      <div className={ styles.member } style={{ width: `${ getBarLength(memberValue, max) }%` }} />
      <div className={ styles.peer } style={{ width: `${ getBarLength(peerValue, max) }%` }} />
      <div className={ styles.other } style={{ width: `${ getBarLength(otherValue, max) }%` }} />
    </div>
  )
}
